var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.5,
    fill: "#F8EEDF",
    stroke: "#E9E0D3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16075_40150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9993 14.667C35.3593 14.667 41.3327 20.6403 41.3327 28.0003C41.3327 35.3603 35.3593 41.3337 27.9993 41.3337C20.6393 41.3337 14.666 35.3603 14.666 28.0003C14.666 20.6403 20.6393 14.667 27.9993 14.667ZM20.03 32.555C21.9873 35.475 24.926 37.3337 28.2127 37.3337C31.498 37.3337 34.438 35.4763 36.394 32.555C34.175 30.4811 31.2499 29.3294 28.2127 29.3337C25.175 29.3291 22.2494 30.4808 20.03 32.555ZM27.9993 26.667C29.0602 26.667 30.0776 26.2456 30.8278 25.4954C31.5779 24.7453 31.9993 23.7279 31.9993 22.667C31.9993 21.6061 31.5779 20.5887 30.8278 19.8386C30.0776 19.0884 29.0602 18.667 27.9993 18.667C26.9385 18.667 25.9211 19.0884 25.1709 19.8386C24.4208 20.5887 23.9993 21.6061 23.9993 22.667C23.9993 23.7279 24.4208 24.7453 25.1709 25.4954C25.9211 26.2456 26.9385 26.667 27.9993 26.667Z",
    fill: "#B17F34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16075_40150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/userAvatar.2510cf68f535d84d8965d4fd52519a55.svg";
export { ForwardRef as ReactComponent };